module.exports = __webpack_public_path__ + "img/3.eaa8b5c3.jpg";